import React from "react";
import { Drawer, Card, Row, Col, Typography } from "antd";

const { Title } = Typography;

const HoldList = ({ visible, onClose, invoices }) => {
  const totalCount = invoices && invoices.length ? invoices.length : 0;

  return (
    <Drawer
      title="Hold Invoices"
      placement="right"
      width={900} // bigger width for 3-column layout
      onClose={onClose}
      open={visible}
    >
      {/* Total Count */}
      <Title level={5}>Total Hold Invoices: {totalCount}</Title>

      <Row gutter={[16, 16]}>
        {invoices && invoices.length > 0 ? (
          invoices.map((item) => {
            const contact =
              item.Contact && item.Contact.length > 0 ? item.Contact[0] : {};
            return (
              <Col span={8} key={item.id}>
                <Card
                  title={`Invoice #: ${item.invoice_number}`}
                  bordered={true}
                  style={{ height: "100%" }}
                >
                  {/* <p>
                    <b>Order #:</b> {item.order_number}
                  </p> */}
                  <p>
                    <b>Status:</b> {item.status || "N/A"}
                  </p>
                  <p>
                    <b>Bill:</b> {item.bill}
                  </p>
                  {/* <p>
                    <b>Payment:</b> {item.payment}
                  </p> */}
                  {/* <p>
                    <b>Due:</b> {item.due}
                  </p> */}
                  <p>
                    <b>Date:</b> {item.issue_date}
                  </p>
                  {/* <p>
                    <b>Customer:</b> {contact.name || "N/A"}
                  </p> */}
                  <p>
                    <b>Phone:</b> {contact.phone || "N/A"}
                  </p>
                  <p>
                    <b>Location:</b> {item.Location_name || "N/A"}
                  </p>
                  <p>
                    <b>Sales Person:</b> {item.Sales_person_name || "N/A"}
                  </p>
                  <p>
                    <b>Total Items:</b> {item.quantity}
                  </p>
                </Card>
              </Col>
            );
          })
        ) : (
          <Col span={24}>
            <p>No Hold Invoices found</p>
          </Col>
        )}
      </Row>
    </Drawer>
  );
};

export default HoldList;
